/**
 * Queue + IVR types (Phase 4 Task 1).
 *
 * Pure type/value module shared by `apps/worker` (ACD handler, IVR engine),
 * `apps/api` (queue + IVR CRUD routes), and `apps/web` (queue panel, IVR
 * builder).
 */
export const RoutingStrategy = {
    RING_ALL: 'RING_ALL',
    ROUND_ROBIN: 'ROUND_ROBIN',
    LEAST_RECENT: 'LEAST_RECENT',
    FEWEST_CALLS: 'FEWEST_CALLS',
    SKILLS_BASED: 'SKILLS_BASED',
    PRIORITY: 'PRIORITY',
    TOP_DOWN: 'TOP_DOWN',
    LONGEST_IDLE_AGENT: 'LONGEST_IDLE_AGENT',
    RING_PROGRESSIVELY: 'RING_PROGRESSIVELY',
};
export const IvrNodeAction = {
    PLAY_AUDIO: 'play_audio',
    COLLECT_DTMF: 'collect_dtmf',
    ROUTE_TO_QUEUE: 'route_to_queue',
    TRANSFER: 'transfer',
    VOICEMAIL: 'voicemail',
    CONDITION: 'condition',
    HANGUP: 'hangup',
};
//# sourceMappingURL=queue.js.map